import { useState } from 'react';
import { Link } from 'react-router-dom'
import Styles from "../styles.module.scss";
import AuthHead from "../AuthHead";
import AuthMedia from '../authMedia';
import Headline5 from '../../../components/headings/Headline5';
import { Auth } from "aws-amplify";
import { ForgotPasswordForm } from './forgotform';
import workIcon from '../../../assets/images/work-anywhere.svg';
import globalIcon from '../../../assets/images/earn-globaly.svg';
import edgeIcon from '../../../assets/images/work-with-edge.svg';
import NotificationAlert from '../../../components/notification';
import mixpanelData from '../../../utils/mixpanel';
import { getAPI } from '../../../api/apis';
import { REACT_APP_CANDIDATE_FREELANCER } from '../../../utils/common';

Auth.configure({
  userPoolId: "ap-south-1_xW3Zsub3t",
  userPoolWebClientId: "2jn6qgntppsud848ri333cud5s", // app client id
  region: "ap-south-1",
  oauth: {
    region: "ap-south-1",
    domain: "http://authmyworkplace.ellow.io",
    scope: ["phone", "email", "openid", "aws.cognito.signin.user.admin", "profile"],
    redirectSignIn: "https://myworkplace.ellow.io/login?provider=google",
    redirectSignOut: "https://myworkplace.ellow.io/login",
    responseType: "code" // or 'token', note that REFRESH token will only be generated when the responseType is code
  }
})




function ForgotPassword() {

  const [error, setError] = useState<string>('')
  const [alert, setAlert] = useState<boolean>(false)
  const [disable, setDisable] = useState<boolean>(false)

  const submitValues = (data: any) => {
 
    setDisable(true)
    const encoded = encodeURIComponent(data.email)
    setError('')
    getAPI( REACT_APP_CANDIDATE_FREELANCER + `/profile-completion-status?email=${encoded}`).then((response) => {
      if(response.data.length === 0) {
        setError('This Email address is not registered with us')
        mixpanelData('New MWP - Forgot password', {
          'Success':  false,
          'distinct_id': data.email,
          'Email': data.email
        }) 
      }
      if(response.data[0].provider === 'google') {
        setError('You are not allowed to use this functionality as you have registered using the Google sign in option')
      }else {
        Auth.forgotPassword(data.email).then(result => {
          setAlert(true)
          setTimeout(() => {
            setAlert(false)
          }, 4000);
          mixpanelData('MWP-Forgot Password', {
            'source': "freelancer login with his account",
            'success':  true,
            'distinct_id': data.email,
            'Email': data.email
          })
          mixpanelData('New MWP - Forgot password', {
            'Success':  true,
            'distinct_id': data.email,
            'Email': data.email
          })
        })
        .catch(err => {
          setError(err.message) 
        })
      }
    })
    setDisable(false)
  }

const alertOnclose = () => {
  setAlert(false);
}

  return (
    <section className="App">
      {alert && <NotificationAlert closable={true} onClose={alertOnclose}>A mail has been sent to your registered mail address, please find the link attached with the mail to update your password.</NotificationAlert> }
      <div className={Styles.authWapper}>
        <div className={Styles.loginForm}>
          
          <AuthHead />
          <div className={Styles.alignCenter}>
          <aside className={Styles.loginSignupWapper}>   
            <Headline5>Forgot Your Password ?</Headline5>
            <div className={Styles.loginWith}>
                  <ForgotPasswordForm  ClickHandler={submitValues} disable={disable}/>
              {error ?

                <div><p className="error-message">{error}</p></div>
                :
                <div></div>

              }
                
              <div className={Styles.alreadyRegistered}>Don’t have an ellow account? <Link to="/signup">Sign up</Link></div> 
             
                 
            </div>
            
          </aside>
          <div className={Styles.signupWith}>
            <div className={Styles.signUpFeatures}>
              <figure><img src={workIcon} alt="Work Anywhere" width="98" height="65" /></figure>
              <figcaption>Work<br />Anywhere</figcaption>
            </div>
            <div className={Styles.signUpFeatures}>
              <figure><img src={globalIcon} alt="Earn Global Pay" width="65" height="54" /></figure>
              <figcaption>Earn<br />Global Pay</figcaption>
            </div>
            <div className={Styles.signUpFeatures}>
              <figure><img src={edgeIcon} alt="Work with cutting edge companies" width="36" height="46" /></figure>
              <figcaption>Work with cutting edge companies</figcaption>
            </div>
          </div>
          </div>
          {/* <div className={Styles.privacyPolicy}>
            By creating an account, I agree to receive Arc communications via email,
            and agree with the Ellow <Link to="/">Terms of Service</Link>, <Link to="/">Privacy Policy</Link>, and <Link to="/">Cookie Policy</Link>.
            I understand that I can unsubscribe at any time.
          </div> */}
        </div>
        <AuthMedia/>
      </div>
    </section>
  );
}

export default ForgotPassword;
